import createModalModel from './lib/create_modal_model';

export default createModalModel({
  modelName: 'FbPagesSelection',
  properties: {},
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/modal/fb_pages_selection.js